
export class ProfileSection {
  public sectionKey: string = "";
  public displayName: string = "";
  public skipEnabled: boolean = false;
  public closeEnabled: boolean = false;
  public iconKey: string = "";
  public estimatedTime: number = 0;
}

export class ProfileWizardConfig {
  public enabled: boolean = false;
  public profileSections: ProfileSection[] = [];
}